import { observable, toJS, flow, action } from "mobx";
import {
	getPrivateNetworks,
	createPrivateNetwork,
	renamePrivateNetwork,
	deletePrivateNetworks
} from "services/privatenetworks";
import { registerHandler, delay } from "services/api";
import { message } from "antd";
import _ from "lodash";

export default class PrivateNetworksStore {
	constructor() {
		this.privateNetworks = observable.array([]);
		this.ui = this.getUI();
	}

	getUI = () => {
		let ui = {
			loadingPrivateNetworks: false,
			addEditPrivateNetworkDialogVisible: false,
			editedPrivateNetwork: null, //When editedPrivateNetwork is not null, it means that we are editing that private network
			renamingPrivateNetwork: false,
			deletingPrivateNetworks: false,
			creatingPrivateNetwork: false
		};
		return observable.object(ui);
	};

	@action
	showAddPrivateNetworkDialog = () => {
		this.ui.addEditPrivateNetworkDialogVisible = true;
		this.ui.editedPrivateNetwork = null;
	};

	@action
	hideAddEditPrivateNetworkDialog = () => {
		this.ui.addEditPrivateNetworkDialogVisible = false;
		this.ui.editedPrivateNetwork = null;
	};

	@action
	showEditPrivateNetworkDialog = privateNetwork => {
		this.ui.addEditPrivateNetworkDialogVisible = true;
		this.ui.editedPrivateNetwork = privateNetwork;
	};

	createPrivateNetwork = flow(function*(name) {
		this.ui.creatingPrivateNetwork = true;
		const response = yield createPrivateNetwork(name);
		this.ui.creatingPrivateNetwork = false;

		if (response == null) {
			message.error("Failed to create private network. Unknown error", 3);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully created a new private network", 3);
		this.ui.addEditPrivateNetworkDialogVisible = false;
		this.ui.editedPrivateNetwork = null;
	});

	remoteRenamePrivateNetwork = flow(function*(privateNetwork) {
		this.ui.renamingPrivateNetwork = true;
		const response = yield renamePrivateNetwork(privateNetwork);
		this.ui.renamingPrivateNetwork = false;
		if (response == null) {
			message.error("Failed to rename the private network. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully rename the private network", 3);
		this.ui.addEditPrivateNetworkDialogVisible = false;
		this.ui.editedPrivateNetwork = null;
	});

	@action
	renamePrivateNetwork = privateNetwork => {
		const foundIndex = this.privateNetworks.findIndex(el => {
			return el.id == privateNetwork.id;
		});

		if (foundIndex != -1) {
			this.privateNetworks[foundIndex].name = privateNetwork.name;
		}
	};

	remoteDeletePrivateNetworks = flow(function*(ids) {
		this.ui.deletingPrivateNetworks = true;
		const response = yield deletePrivateNetworks(ids);
		this.ui.deletingPrivateNetworks = false;
		if (response == null) {
			message.error("Failed to delete selected private networks. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully deleted selected private networks", 3);
	});

	@action
	deletePrivateNetworks = ids => {
		_.remove(this.privateNetworks, privateNetwork => {
			return ids.includes(privateNetwork.id);
		});
        // console.log("Delete Private Networks");
        // console.log(ids);
		// this.privateNetworks = observable.array(
		// 	this.privateNetworks.slice().filter(privateNetwork => !ids.includes(privateNetwork.id))
        // );
        // console.log(this.privateNetworks);
	};

	@action
	addPrivateNetwork = privateNetwork => {
		this.privateNetworks.push(privateNetwork);
	};

	@action
	updateAccountCount = (privateNetworkId, count) => {
		for (let i = 0; i < this.privateNetworks.length; i++) {
			let privateNetwork = this.privateNetworks[i];
			if (privateNetwork.id == privateNetworkId) {
				privateNetwork.count = count;				
				return;
			}
		}
	}

	loadPrivateNetworks = flow(function*() {
		this.ui = this.getUI();
		this.ui.loadingPrivateNetworks = true;
		const response = yield getPrivateNetworks();
		this.ui.loadingPrivateNetworks = false;
		if (response == null) {
			message.error("Failed to load private networks. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}
		this.privateNetworks = observable.array(response.objects);

		registerHandler([
			{
				path: "private_networks",
				handler: (err, msg) => {
					if (err != null) return;
					const obj = JSON.parse(msg.body);
					if (obj.action == "addNew") {
						var privateNetwork = obj.object;
						privateNetwork.count = 0;
                        // console.log(privateNetwork);
						this.addPrivateNetwork(privateNetwork);
						return;
					}

					if (obj.action == "editName") {
						this.renamePrivateNetwork({
							name: obj.name,
							id: obj.id							
						});
						return;
					}

					if (obj.action == "deleted") {
	                    //Delete by Id
						this.deletePrivateNetworks(obj.ids);
						return;
					}

					if (obj.action == "countChanged") {						
						this.updateAccountCount(obj.id, obj.count);
						return;
					}
				}
			}
		]);
	});
}
